<div class="d-flex flex-column align-items-start gap-3">
    @if (hasExistingVisions) {
        <span>
            @if (currentNominatedPersonId) {
                <adapt-link-person [personId]="currentNominatedPersonId"
                                   imageSize="sm"></adapt-link-person>
                has been nominated to drive the integrated vision.
            }
        </span>
        <button class="btn btn-primary align-self-center"
                [adaptBlockingClick]="gotoVisionPage">Navigate to vision page</button>
        <button class="btn btn-primary align-self-center"
                [adaptBlockingClick]="assignIntegratedVision">Nominate vision integrator</button>
    } @else {
        <span>No vision has been recorded in the adapt platform. Proceeding is not possible until the owners document their vision.</span>
    }
</div>
